import { render, staticRenderFns } from "./ProviderPlan.vue?vue&type=template&id=96710650&scoped=true"
import script from "./ProviderPlan.vue?vue&type=script&lang=js"
export * from "./ProviderPlan.vue?vue&type=script&lang=js"
import style0 from "./ProviderPlan.vue?vue&type=style&index=0&id=96710650&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96710650",
  null
  
)

export default component.exports